import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import Card, { CardDescription, CardFooter, CardHeader } from '../../components/Card';
import CreatePageButton from '../../components/CreatePageButton';
import EmptyState from '../../components/EmptyState';
import Header from '../../components/Header';
import IconFeatureFlags from '../../components/icons/IconFeatureFlags';
import Loader from '../../components/Loader';
import PageStatus from '../../components/PageStatus';
import SingleColGrid from '../../components/SingleColGrid';
import { ROUTES } from '../../routes/routes';
import { PricingPage } from '../../types/pricingPage';
import { useAxios } from '../../utils/hooks';
import Preview from '../PricingPages/NewPage/Preview';

export default function FeatureFlags() {
    const { addToast } = useToasts();
    const axios = useAxios();
    const [pages, setPages] = useState<PricingPage[]>();
    useEffect(() => {
        if (!axios.current) {
            return;
        }

        axios.current
            .get<PricingPage[]>('/pricing-pages')
            .then((res) => setPages(res.data))
            .catch((err) =>
                addToast('Something went wrong. Please reload the page and try again.', { appearance: 'error' })
            );
    }, [axios, addToast]);
    return (
        <div className="p-4 w-full text-center">
            <Header>
                <IconFeatureFlags className="inline w-6 mr-3" /> Feature Flags
            </Header>
            <p className="px-8 py-4 text-left">Choose a Pricing Page to configure Feature Flags for:</p>
            <div className="p-4">
                {!pages && <Loader full />}
                {pages?.length === 0 && (
                    <EmptyState
                        body={
                            <div className="md:w-1/2 m-auto py-4">
                                <h4 className="text-xl">No Pages Found</h4>
                                <span>You can create a new pricing page by clicking the button below</span>
                                <div className="md:w-48 m-auto mt-6">
                                    <CreatePageButton />
                                </div>
                            </div>
                        }
                    />
                )}
                {pages && pages.length > 0 && (
                    <SingleColGrid>
                        {pages.map((page) => (
                            <PageInfo key={page.id} page={page} />
                        ))}
                    </SingleColGrid>
                )}
            </div>
        </div>
    );
}

function PageInfo({ page }: { page: PricingPage }) {
    const history = useHistory();
    const handleClickChoose = () => {
        history.push(ROUTES.FEATURE_FLAGS_CONFIGURE.replace(':pageId', page.id));
    };
    return (
        <Card>
            <CardHeader onClick={handleClickChoose} status={<PageStatus page={page} disabled />}>
                <div style={{ zoom: '70%' }}>
                    <Preview page={page} centered />
                </div>
            </CardHeader>
            <CardDescription
                title={
                    <button
                        onClick={handleClickChoose}
                        className="font-medium text-lg inline-block mb-2 hover:text-blue-400"
                    >
                        {page.name}
                    </button>
                }
            />
            <CardFooter></CardFooter>
        </Card>
    );
}
